import { httpClient } from '../httpClient/httpClient';

export enum JobType {
  Test = 1,
  SyncProjectsToGarp = 2,
  AiPrompt = 3,
  CopyArticles = 4,
  CreateArticles = 5,
}
export enum JobState {
  Waiting = 0,
  Running = 1,
  Finished = 2,
  Failed = 3,
  Cancelled = 4,
}

export type JobTypeKeys = keyof typeof JobType;
export type JobStateKeys = keyof typeof JobState;

export interface JobRecord {
  id: number;
  created: string;
  finished: string | null;
  type: JobType;
  state: JobState;
  latestMessage: string;
}

export enum JobEntityType {
  Sample = 1,
  ProductApproval = 2,
  CompositionGroup = 3,
  Variant = 4,
  Article = 5,
  Concept = 6,
  Customer = 7,
  Supplier = 8,
  Inquiry = 9,
  Offer = 10,
}

export interface JobEntityCount {
  type: JobEntityType;
  count: number;
}

export interface JobEntity {
  id: number;
  type: JobEntityType;
  label: string;
  secondaryLabel: string;
  context: string;
}

export interface JobListItem extends JobRecord {
  userName: string;
  percentComplete: number;
  entityCount: number;
  entityCounts: JobEntityCount[];
}

export interface JobDirectorySummary {
  running: number;
  waiting: number;
  needsAttention: number;
  completed: number;
}

export interface JobDirectory {
  items: JobListItem[];
  totalItems: number;
  summary: JobDirectorySummary;
  types: JobType[];
}

export interface JobUpdate {
  id: number;
  timestamp: string;
  percentComplete: number | null;
  state: JobState;
  message: string;
  devMessage: string;
  entity: JobEntity | null;
}

export interface JobDetails extends JobListItem {
  userBranch: string;
  updates: JobUpdate[];
}

export interface JobSearchQuery {
  searchTerm: string;
  state: JobState | null;
  type: JobType | null;
  page: number;
  pageSize: number;
  days: number;
  showAll: boolean;
}

export const jobRecordsApi = {
  search: (params: JobSearchQuery) =>
    httpClient.get<JobDirectory>('jobs', { params }),
  get: (jobId: number) => httpClient.get<JobDetails>(`jobs/${jobId}`),
};
